// Bu dosyadaki kod sitenizin her sayfasına yüklenir

$w.onReady(function () {Write});
